<template>
    <modal
        name="carrito-aviso"
        transition="pop-out"
        :width="800"
        height="auto"
        id="carrito-aviso"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">{{$t('carrito.tiempo_aviso_titulo')}} <i class="fas fa-stopwatch" style="color: #ff0000;"></i></h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">{{$t('carrito.tiempo_aviso_hora')}} {{time == true ? '00:00': time}}</h3>
                <h4 class="text-danger">{{$t('carrito.mensaje_aviso')}}</h4>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="close()">{{$t('carrito.tiempo_modal_cerrar')}}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    props: ['secondsLeft'],
    data(){
        return{
            time: null,
            interval: null,         
        }
    },
    watch: {
        secondsLeft(newVal) {
            if (newVal !== null && newVal > 0) {
                this.startCountdown(newVal);
            } 
        }
    },
    methods: {
        startCountdown(seconds) {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }

            let remainingTime = seconds;
            const minutes_ = Math.floor(remainingTime / 60);
            const seconds_ = remainingTime % 60;

            this.time = `${minutes_}:${seconds_ < 10 ? '0' : ''}${seconds_}`;
            this.interval = setInterval(() => {
                const minutes = Math.floor(remainingTime / 60);
                const seconds = remainingTime % 60;
                this.time = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
                --remainingTime;
            }, 1000);
        },
        close() {
            this.$emit('close');
        }
    },
}

</script>